import api from "@/services/api.service";
import { get } from "lodash";
import { ActionTree } from "vuex";

import { ArmDisarmState, SiteTreeNodeWithOnTestEvents } from "./types";
import { Region, RootState } from "../types";
import { FilteredEvent, SiteTreeNode } from "@/store/eventqueue/types";
import { getLocalRegion } from "@/utils/region-utils";

export const actions: ActionTree<ArmDisarmState, RootState> = {
	async sitesTreeGet({ commit, rootGetters, rootState }, region: Region) {
		const data: SiteTreeNode[] = await api.loadGroupsTreeWithRegion(false, region.url);

		const featuresList = rootState["featuresList"];
		const onTestEnabled = get(featuresList, ["Alarms", "EventQueue", "SeeSiteArmedState", "OnTest"]);
		const onTestEvents: FilteredEvent[] = onTestEnabled ? rootGetters["eventqueue/getSitesOnTestEvents"] : [];

		const siteTreeNodeWithOnTestEvents: SiteTreeNodeWithOnTestEvents = { siteTree: data, onTestEvents };

		commit("setTree", {
			data: siteTreeNodeWithOnTestEvents,
			regionID: region?.regionId ?? getLocalRegion().regionId
		});
	}
};
